import { escapeHtml } from "@simplyk/common";

const HTML_TAG_PATTERN = /<[a-z][^>]*>/i;

export const convertPlainTextToParagraphs = (text: string): string => {
  if (HTML_TAG_PATTERN.test(text)) {
    return text;
  }

  return text
    .split(/\r?\n/)
    .map((line) => `<p>${line ? escapeHtml(line) : "<br>"}</p>`)
    .join("");
};
